import { notify } from '../../services/notification'

// error handle funtion
export function errorHandler(errors) {

  // 401 is handled globally by axiosInterceptor — skip here
  if (errors?.response?.status === 401) return errors;

  if (errors?.response?.status === 500 && errors?.response?.data?.message) {
    notify.error(errors?.response?.data?.message)
    return errors
  }

  if (errors?.response?.status === 403) {
    notify.error(errors?.response?.data?.msg||errors?.response?.data?.errors?.[0]||errors?.response?.data?.Message)
    return errors
  }
  if (errors?.response?.status === 404) {
    notify.error(errors?.response?.data?.msg || errors?.response?.data?.detail || errors?.response?.data?.message)
    return errors
  }

  if (errors?.response?.status === 400) {
    const data = errors?.response?.data;
    const message =
      data?.redirect_url?.[0] ||
      data?.message ||
      data?.error ||
      data?.detail ||
      data?.errors?.non_field_errors?.[0] ||
      data?.errors?.[0].training_category?.[0] ||
      (Array.isArray(data?.errors) ? data.errors[0] : null) ||
      (typeof data === 'object' && data !== null
        ? Object.values(data).map(v => (Array.isArray(v) ? v[0] : v)).find(v => v && typeof v === 'string')
        : null) ||
      'Something went wrong. Please try again.';
    notify.error(message);
    return errors;
  }

  if (errors?.response?.data?.[0]) {
    notify.error(errors?.response?.data?.[0])
    return errors
  }
}
